import {
	Box,
	Button,
	CircularProgress,
	FormControl,
	InputLabel,
	Modal,
	OutlinedInput,
	Typography,
} from "@mui/material";
import { useCallback, useContext, useState } from "react";
import { useBus, useListener } from "react-bus";
import { AppContext } from "../../../../Contexts/AppContext";
import { isNil } from "lodash";
import { AddUserNotificationModalProps } from "./types";
import { CreateUserNotificationDto } from "../../../../models/UserNotifications";
import UserNotificationApi from "../../../../api/user-notification";

const style = {
	position: "absolute" as "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	width: 400,
	bgcolor: "background.paper",
	border: "2px solid #000",
	boxShadow: 24,
	p: 4,
};

export default function AddUserNotificationModal(
	props: AddUserNotificationModalProps
) {
	const [userNotification, setUserNotification] =
		useState<CreateUserNotificationDto>({
			email: "",
			name: "",
			permissionaryId: "",
		});
	const [open, setOpen] = useState(false);
	const [loading, setLoading] = useState(false);
	const handleOpen = useCallback(() => setOpen(true), []);
	const handleClose = () => setOpen(false);
	const bus = useBus();

	const { userContext, setSnackBar, snackBar } = useContext(AppContext);

	const create = useCallback(async () => {
		const createDto: CreateUserNotificationDto = userNotification;

		if (isNil(userContext?.permissionaryId)) {
			return;
		}
		try {
			setLoading(true);
			await UserNotificationApi.create({
				accessToken: localStorage.getItem("accessToken"),
				createDto: {
					...createDto,
					permissionaryId: userContext?.permissionaryId || "",
				},
			});

			bus.emit("reloadUserNotifications");
			handleClose();

			setSnackBar({
				...snackBar,
				open: true,
				message: "Notificacion creada con exito",
				autoHideDuration: 6000,
				severity: "success",
			});
		} catch (error: any) {
			console.error(error);
			setSnackBar({
				...snackBar,
				open: true,
				message: "Error al crear la notificacion",
				autoHideDuration: 6000,
				severity: "error",
			});
		} finally {
			setLoading(false);
		}
	}, [userContext, userNotification, setSnackBar]);

	useListener("openAddUserNotificationModal", handleOpen);
	return (
		<Modal
			open={open}
			onClose={handleClose}
			aria-labelledby='modal-modal-title'
			aria-describedby='modal-modal-description'>
			<Box sx={style}>
				<Typography id='modal-modal-title' variant='h6' component='h2'>
					Agregar Notificacion de Usuario
				</Typography>
				<div style={{ marginBottom: "15px", width: "100%" }}>
					<FormControl sx={{ m: 1, width: "90%" }} variant='outlined'>
						<InputLabel htmlFor='outlined-adornment-name'>Nombre</InputLabel>
						<OutlinedInput
							id='outlined-adornment-name'
							type={"text"}
							placeholder='Nombre'
							label='Nombre'
							onChange={(event) => {
								setUserNotification({
									...userNotification,
									name: event.target.value,
								});
							}}
							onKeyUp={(event) => {
								if (event.key === "Enter") {
									create();
								}
							}}
						/>
					</FormControl>
				</div>
				<div style={{ marginBottom: "15px", width: "100%" }}>
					<FormControl sx={{ m: 1, width: "90%" }} variant='outlined'>
						<InputLabel htmlFor='outlined-adornment-email'>Email</InputLabel>
						<OutlinedInput
							id='outlined-adornment-email'
							type={"text"}
							placeholder='Email'
							label='Email'
							onChange={(event) => {
								setUserNotification({
									...userNotification,
									email: event.target.value,
								});
							}}
							onKeyUp={(event) => {
								if (event.key === "Enter") {
									create();
								}
							}}
						/>
					</FormControl>
				</div>
				<div style={{ marginTop: "10px", textAlign: "center" }}>
					{loading ? (
						<CircularProgress size={30} />
					) : (
						<Button
							variant='contained'
							color='primary'
							sx={{
								width: "40%",
								marginTop: 2,
							}}
							onClick={() => create()}>
							Crear
						</Button>
					)}
				</div>
			</Box>
		</Modal>
	);
}
